export default function SvgAdd() {
    return (
      <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17px"
        cursor="pointer"
        viewBox="0 0 24 24"
        >
        <g>
            <g
            fill="none"
            stroke="#444"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            data-name="add"
            >
            <path d="M12 19L12 5"></path>
            <path d="M5 12L19 12"></path>
            </g>
        </g>
    </svg>
    </>
  );
}
